// Toate textele, logo-urile și pozele sunt preluate 1:1 de pe https://fat-frumos.com.ro/
// Nu modificăm conținutul — doar layout-ul.

const CDN = "https://fat-frumos.com.ro/wp-content/uploads/";
const u = (p) => CDN + p;

export const ASSETS = {
  logo: "/brand-assets/2025/06/FatFrumos_Logo3.png",
  heroPortrait: "/brand-assets/2026/03/Untitled-44.png",
  socialMedia: "/brand-assets/2025/10/social_media.png",
  actiuniFizic: "/brand-assets/2025/10/actiunifizic.png",
  actiuniCustom: "/brand-assets/2025/10/actiunicustom.png",
  customHero: "/brand-assets/2025/10/Untitled-38.jpeg",
  ceFacemPhoto: "/brand-assets/2025/10/image00011-scaled-1.jpeg",
  digitalPhoto: "/brand-assets/2025/10/caravana-5.jpg",
  isicWhite: "/brand-assets/2026/01/ISIC_logo_WHITE_rgb.png",
  eycaWhite: "/brand-assets/2026/01/EYCA_CT_alb.png",
  isicColor: "/brand-assets/logos/ISIC_logo_COLOUR_rgb.png",
  eycaColor: "/brand-assets/logos/EYCA_CT_color.png",
};

export const NAV = [
  { label: "Cine suntem", to: "/despre-noi" },
  { label: "Ce oferim", to: "/ce-oferim" },
  { label: "Servicii custom", to: "/campanii-custom" },
  { label: "Cei ce ne-au ales", to: "/#branduri" },
];

export const PROJECTS = [
  { label: "International Student Identity Card", href: "https://isic.ro/" },
  { label: "Cardul European de Tineret", href: "https://carduldetineret.ro/" },
  { label: "ISIC Jobs", href: "https://jobs.isic.ro/" },
];

export const CONTACTS = [
  {
    name: "Mihai Tăpălagă",
    phone: "0722.428.045",
    email: "mihai.tapalaga@isic.ro",
    linkedin: "https://www.linkedin.com/in/mihai-tapalaga-mba-71b62214/",
    photo: "/brand-assets/2026/01/mihai.jpg",
  },
  {
    name: "Andrei Dumitru",
    phone: "0728.230.247",
    email: "andrei.dumitru@isic.ro",
    linkedin: "https://www.linkedin.com/in/andrei-isic/",
    photo: "/brand-assets/2026/01/andrei_isic_jobs_2020_2.jpg",
  },
];

export const HOME = {
  heroKicker: "Făt-Frumos, făurit de ISIC și Cardul European de Tineret",
  heroTitle: "Povestitorul brandurilor care vor să inspire tinerii",
  heroText:
    "Cu acces direct la peste 400.000 de studenți și tineri, canale proprii și prezență în campusuri din toată țara, transformăm obiectivele brandurilor în campanii care se văd, se trăiesc și generează reacție.",
  heroCta: "Brandurile care ne-au ales",
  cineKicker: "Cine suntem?",
  cineTitle: "Nu venim din tărâmuri îndepărtate.",
  cineSubtitle: "Venim din campusuri, feed-uri și inboxuri.",
  cineText: [
    "Suntem echipa din spatele ISIC România, Cardului European de Tineret și ISIC Jobs. Asta înseamnă mai mult decât reach: comunități proprii, canale directe de comunicare, parteneriate cu universități și acces real în campusuri din toată țara.",
    "De peste 20 de ani ajutăm brandurile să ajungă la studenți și tineri în contexte în care aceștia aleg deja să fie prezenți, prin comunități construite și dezvoltate în timp.",
  ],
  cineCta: "Află cine suntem",
  ceFacemTitle: "Ce facem, de se aude până în regatul tinerilor",
  ceFacemText:
    "De la inbox la campus, punem brandurile în contact cu tinerii printr-un ecosistem pe care îl construim și îl administrăm direct.",
  digital: {
    title: "Digital",
    stats: [
      { value: "290.000+", label: "în baza activă de newsletter" },
      { value: "90.000+", label: "utilizatori accesibili prin push notifications" },
    ],
    items: [
      "Social media și platforme web proprii",
      "Colaborări cu asociații și comunități studențești",
    ],
  },
  real: {
    title: "În lumea reală",
    stats: [
      { value: "50+", label: "universități în fiecare an" },
      { value: "30+", label: "orașe" },
      { value: "150.000+", label: "interacțiuni directe în Caravana ISIC 2025" },
      { value: "25.000", label: "Student Kit-uri distribuite anual" },
    ],
  },
  services: [
    {
      title: "Campanii integrate",
      text: "Newsletter, push notifications, social media, web, campus, evenimente și sampling, combinate în funcție de obiectivul brandului.",
      cta: "Descoperă ce oferim",
      to: "/ce-oferim",
      accent: "leaf",
    },
    {
      title: "Campanii custom",
      text: "De la activări în campus și evenimente până la campanii țintite și sampling, construim proiecte adaptate obiectivului, publicului și contextului potrivit pentru brand.",
      cta: "Descoperă campaniile custom",
      to: "/campanii-custom",
      accent: "brand",
    },
  ],
  stats: [
    { value: "400.000+", label: "tineri în comunitate" },
    { value: "20+", label: "ani de experiență" },
    { value: "50+", label: "universități în fiecare an" },
  ],
  brandsTitle: "Câteva dintre brandurile care ne-au ales",
};

export const BRANDS = [
  { name: "Heineken", slug: "heineken", logo: "/brand-assets/2025/10/heineken_logo.jpeg" },
  { name: "Logitech", slug: "logitech", logo: "/brand-assets/2025/10/logitech-1-768x521-1.jpeg" },
  { name: "Sephora", slug: "sephora", logo: "/brand-assets/2025/10/sephora_logo.jpeg" },
  { name: "BRD", slug: "brd", logo: "/brand-assets/2025/10/brd_logo.jpeg" },
  { name: "Kaufland", slug: "kaufland", logo: "/brand-assets/2025/10/kaufland_logo.jpeg" },
  { name: "YOXO", slug: "yoxo", logo: "/brand-assets/2025/10/yoxo_logo.jpeg" },
  { name: "iStyle", slug: "istyle", logo: "/brand-assets/2026/01/Untitled-43.jpeg" },
  { name: "Samsung", slug: "samsung", logo: "/brand-assets/2025/10/samsung_logo.jpeg" },
  { name: "Turkish Airlines", slug: "turkish-airlines", logo: "/brand-assets/2025/10/turkish_airlines.jpeg" },
];

export const DESPRE = {
  kicker: "Cine suntem",
  title: "Cine suntem",
  intro: [
    "Făt-Frumos este echipa care conectează brandurile cu studenții și tinerii din România prin comunitățile, canalele și proiectele construite în jurul ISIC România, Cardului European de Tineret și ISIC Jobs.",
    "Nu pornim de la o audiență pe care trebuie să o căutăm. Pornim de la comunități cu care vorbim în fiecare zi, online, în aplicații, în universități și în campusuri din toată țara.",
  ],
  stats: [
    { value: "400.000+", label: "tineri în comunitate" },
    { value: "290.000+", label: "în baza activă de newsletter" },
    { value: "90.000+", label: "utilizatori accesibili prin push" },
    { value: "50+", label: "universități în fiecare an" },
  ],
  isic: {
    title: "ISIC România",
    body: [
      "ISIC este legitimația internațională pentru studenți, prezentă în România de peste 20 de ani și parte dintr-o rețea globală recunoscută în peste 130 de țări.",
      "În România, comunitatea ISIC numără peste 350.000 de studenți.",
      "Pentru branduri, ISIC înseamnă acces direct la o comunitate tânără, activă și bine definită și la un ecosistem în care studenții interacționează deja cu beneficii, oportunități, conținut, evenimente și parteneri comerciali.",
      "Prin ISIC putem construi campanii digitale, activări în campus, sampling, parteneriate de beneficii, employer branding și proiecte integrate pe termen lung.",
    ],
  },
  eyca: {
    title: "Cardul European de Tineret",
    body: [
      "Cardul European de Tineret face parte din rețeaua European Youth Card Association și se adresează tinerilor cu vârsta de până la 31 de ani.",
      "În România, completează ecosistemul ISIC și ne permite să comunicăm și cu tineri care nu sunt neapărat studenți.",
      "Pentru branduri, înseamnă acces la o comunitate mai largă de tineri și posibilitatea de a construi campanii, beneficii și proiecte dedicate publicului tânăr la nivel național și european.",
    ],
  },
  jobs: {
    title: "ISIC Jobs",
    body: [
      "ISIC Jobs este platforma prin care conectăm studenții și tinerii aflați la început de carieră cu angajatori, joburi, internshipuri și oportunități profesionale.",
      "Pentru companii, ISIC Jobs adaugă ecosistemului nostru o componentă puternică de employer branding și recrutare: campanii dedicate, conținut, promovarea oportunităților, comunicare prin canalele ISIC și activări directe în campus.",
    ],
  },
  why: {
    title: "De ce Făt-Frumos?",
    items: [
      { h: "Acces, nu doar reach.", t: "Comunități proprii de studenți și tineri construite prin ISIC și Cardul European de Tineret." },
      { h: "Canale proprii.", t: "Newsletter, push notifications, social media, platforme web și proiecte dedicate prin care comunicăm direct cu comunitatea." },
      { h: "Prezență reală în campus.", t: "Relații cu universități, asociații și comunități studențești din toată țara." },
      { h: "Online + offline, sub aceeași umbrelă.", t: "De la primul email sau push până la interacțiunea directă cu brandul, produsul sau experiența din campus." },
      { h: "20+ ani de experiență.", t: "Știm unde sunt tinerii, dar mai ales când, cum și în ce context merită să vorbești cu ei." },
    ],
    cta: "Vezi ce putem construi împreună",
  },
};

export const CE_OFERIM = {
  kicker: "Ce oferim",
  title: "Online, offline și tot ce se întâmplă între ele.",
  intro: [
    "Nu credem în campanii construite în jurul unui singur canal. Alegem combinația potrivită în funcție de obiectiv, de la newsletter, push și social media până la campus, evenimente, sampling și interacțiuni directe cu produsul.",
    "Avantajul nostru este că o mare parte dintre aceste puncte de contact fac deja parte din ecosistemele pe care le construim și le administrăm.",
  ],
  digital: {
    title: "În lumea digitală",
    lead: "Intrăm în feed, inbox și telefon prin canale care fac deja parte din viața comunității ISIC și Cardul European de Tineret.",
    channels: [
      { title: "Newsletter", text: "Acces la o bază activă de peste 290.000 de tineri, pentru campanii dedicate, lansări, oferte, conținut și proiecte speciale." },
      { title: "Push notifications", text: "Comunicare directă către peste 90.000 de utilizatori prin notificări scurte, rapide și ușor de integrat în campanii mai ample." },
      { title: "Social media", text: "Campanii și conținut distribuite prin comunitățile ISIC și Cardul European de Tineret, adaptate platformei, mesajului și obiectivului." },
      { title: "Web & landing pages", text: "Vizibilitate în platformele noastre și landing page-uri dedicate pentru campanii, concursuri, lansări, beneficii sau proiecte speciale." },
      { title: "Asociații și comunități studențești", text: "Extindem campaniile prin colaborări cu organizații și comunități studențești relevante din universități din toată țara." },
    ],
  },
  offline: {
    title: "În lumea reală",
    lead: "Uneori cel mai bun mod de a ajunge la un tânăr este să fii exact acolo unde este el. În facultate, în campus, la un eveniment sau într-un moment în care poate vedea, testa și experimenta brandul.",
  },
  caravana: {
    title: "Caravana ISIC",
    text: [
      "În fiecare toamnă, Caravana ISIC duce brandurile direct în campusuri și universități din toată țara.",
      "Construim activări, sampling, experiențe de brand și interacțiuni directe cu studenții, integrate într-un proiect național care face deja parte din calendarul comunității ISIC.",
    ],
    stats: [
      { value: "30+", label: "orașe" },
      { value: "50+", label: "universități" },
      { value: "150.000+", label: "interacțiuni directe în fiecare ediție" },
      { value: "25.000", label: "Student Kit-uri distribuite anual" },
    ],
    extra:
      "Brandurile pot fi integrate prin sampling în Student Kit, standuri și activări dedicate, product trial, concursuri, materiale custom sau campanii care combină prezența fizică din campus cu newsletter, push, social media și web.",
    gallery: [
        "/brand-assets/2025/10/caravana-1.jpg",
        "/brand-assets/2025/10/caravana-12.jpg",
        "/brand-assets/2025/10/caravana-5.jpg",
        "/brand-assets/2025/10/c4.jpg",
        "/brand-assets/2025/10/caravana-7.jpg",
        "/brand-assets/2025/10/caravana-10-scaled-1.jpg",
        "/brand-assets/2025/10/caravana-11.jpg",
      ],
  },
  offlineBlocks: [
    {
      title: "Activări în campus",
      body: [
        "Construim prezențe dedicate pentru brandurile care vor mai mult decât vizibilitate: standuri, experiențe interactive, demonstrații de produs, concursuri, sampling și proiecte adaptate fiecărei universități.",
        "Ne ocupăm de concept, implementare, logistică și integrarea cu celelalte canale ale campaniei.",
      ],
    },
    {
      title: "Sampling & product trial",
      body: [
        "Punem produsele direct în mâna publicului potrivit, în campusuri, la evenimente sau prin Student Pack-urile ISIC.",
        "Samplingul poate funcționa independent sau ca parte dintr-o campanie integrată care continuă în digital prin newsletter, push, social media și landing pages.",
      ],
    },
    {
      title: "Employer branding",
      body: [
        "Prin ISIC Jobs și ecosistemul ISIC conectăm angajatorii cu studenții și tinerii aflați la început de carieră.",
        "Construim campanii de employer branding, promovăm joburi și internshipuri, dezvoltăm conținut dedicat și ducem angajatorii direct în campus prin activări și proiecte speciale.",
      ],
    },
    {
      title: "Parteneriate pe termen lung",
      body: [
        "Nu toate proiectele trebuie să se termine odată cu o campanie.",
        "Integrăm brandurile în ecosistemele ISIC și Cardul European de Tineret prin beneficii dedicate comunității, comunicare recurentă și proiecte construite pentru o relație pe termen lung cu publicul tânăr.",
        "De la retail și tech până la travel, banking, telecom sau servicii, putem transforma un beneficiu relevant într-un motiv constant de interacțiune între brand și comunitate.",
      ],
    },
  ],
  cta: "Hai să vorbim",
};

export const CAMPANII = {
  kicker: "Servicii custom",
  title: "Campanii custom",
  intro: [
    "Nicio campanie nu seamănă cu alta. De aceea, construim campanii custom, de la strategie până la implementare, adaptate obiectivelor, bugetului și publicului fiecărui brand.",
    "Fie că vrei să crești vizibilitatea, să lansezi un produs sau să te conectezi cu studenții și tinerii din România, construim un mix de acțiuni potrivit contextului. Pornim de la obiectiv și ajungem la execuție, fără șabloane.",
  ],
  how: {
    title: "Cum arată o campanie custom?",
    body: [
      "Nu avem o formulă standard. Avem experiență, context și acces direct la comunități de studenți și tineri.",
      "Tu vii cu obiectivul, noi venim cu strategia, execuția și canalele potrivite.",
      "Uneori organizăm evenimente de amploare, alteori activări punctuale în campusuri sau campanii țintite, adaptate unui public clar definit.",
      "Mai jos sunt principalele tipuri de acțiuni pe care le putem integra într-o campanie custom.",
    ],
  },
  actions: [
    {
      index: "01",
      title: "Evenimente de amploare",
      subtitle: "Pentru vizibilitate și impact la scară mare",
      body: [
        "Când obiectivul este să aduni un număr mare de studenți într-un singur loc, dezvoltăm evenimente care creează experiență, nu doar prezență. Lansări de produs, conferințe sau evenimente interactive, gândite special pentru publicul tânăr.",
        "Un exemplu este colaborarea cu Sephora, pentru care am organizat un eveniment dedicat în Aula Magna a Universității din București. Peste 300 de studente au participat la ateliere, demonstrații și activări interactive, într-un format construit special pentru acest public.",
      ],
      gallery: [
        "/brand-assets/2025/10/20191015_141350-1-scaled-1.jpg",
        "/brand-assets/2025/10/20191015_133246-1-scaled-1.jpg",
        "/brand-assets/2025/10/IMG_5752-scaled-1.jpg",
        "/brand-assets/2025/10/IMG_5775-scaled-1.jpg",
        "/brand-assets/2025/10/IMG_5792-scaled-1.jpg",
      ],
    },
    {
      index: "02",
      title: "Activări de tip stand",
      subtitle: "Pentru interacțiuni directe, cu impact rapid",
      body: [
        "În campusuri universitare sau la evenimente mari, un stand bine gândit poate deveni punctul principal de atracție. Construim standuri personalizate, cu activări interactive, demo-uri și echipe pregătite să interacționeze direct cu studenții.",
        "Un exemplu este activarea realizată pentru Logitech la Universitatea Tehnică de Construcții din București, unde am creat un stand cu demo-uri live de produse, simulatoare, competiții și tombole, care au atras constant studenții interesați de tehnologie.",
      ],
      gallery: [
        "/brand-assets/2025/10/image00005-scaled-1.jpeg",
        "/brand-assets/2025/10/image00011-scaled-1.jpeg",
        "/brand-assets/2025/10/image00012-scaled-1.jpeg",
        "/brand-assets/2025/10/image00014-scaled-1.jpeg",
        "/brand-assets/2025/10/image00018-scaled-1.jpeg",
      ],
    },
    {
      index: "03",
      title: "Campanii țintite",
      subtitle: "Pentru mesaje clare, către publicul potrivit",
      body: [
        "Nu toate campaniile au nevoie de volum mare. Uneori, eficiența vine din adresarea unui grup bine definit. Selectăm atent publicul și construim sesiuni dedicate, cu interacțiune directă și conversații relevante.",
        "Un astfel de exemplu este colaborarea cu NN, unde am organizat întâlniri cu studenți interesați de o carieră în domeniul financiar, în cadrul Universității Tehnice de Construcții din București. Campania a fost gândită ca un prim pas în construirea unei relații pe termen lung cu viitorii candidați.",
      ],
      gallery: [
        "/brand-assets/2025/10/WhatsApp-Image-2025-08-11-at-14.35.33-1.jpeg",
        "/brand-assets/2025/10/WhatsApp-Image-2025-08-11-at-14.35.33-3.jpeg",
        "/brand-assets/2025/10/Screenshot-2025-08-11-143804.png",
        "/brand-assets/2025/10/Screenshot-2025-08-11-143822.png",
      ],
    },
    {
      index: "04",
      title: "Sampling cu efect de domino",
      subtitle: "Pentru experiență directă cu produsul",
      body: [
        "Samplingul este una dintre cele mai eficiente forme de interacțiune atunci când este făcut în contextul potrivit. Ne asigurăm că produsul ajunge direct la studenți și tineri, în campusuri, cămine, festivaluri sau evenimente dedicate.",
        "Un exemplu este colaborarea cu Heineken, pentru care am realizat acțiuni de sampling în campusuri, cămine și festivaluri. Peste 150.000 de doze au fost distribuite în cadrul activărilor, generând experiență directă și memorabilitate pentru brand.",
      ],
      gallery: [
        "/brand-assets/2025/10/DSC_0285-1-scaled-1.jpg",
        "/brand-assets/2025/10/h1-1-scaled-1.jpg",
        "/brand-assets/2025/10/h4-1.jpg",
        "/brand-assets/2025/10/Copie-a-fisierului-IMG_7103-scaled-1.jpg",
        "/brand-assets/2025/10/h2-1-scaled-1.jpg",
        "/brand-assets/2025/10/h3-1.jpg",
      ],
    },
  ],
  cta: "Ai un plan? Hai să-l discutăm",
  ctaTitle: "Ai obiectivul. Hai să-i găsim povestea.",
  ctaButton: "Hai să vorbim",
};

export const CONTACT = {
  kicker: "Contact",
  title: "Hai să ne cunoaștem",
  intro:
    "Ai un obiectiv, o idee sau doar începutul unei idei? Spune-ne unde vrei să ajungi și vedem împreună cum putem pune comunitățile și canalele noastre la treabă.",
  formTitle: "Lasă-ne un mesaj",
  fields: {
    name: "Nume",
    company: "Companie",
    email: "Email",
    phone: "Telefon",
    interest: "Ce te interesează?",
    message: "Spune-ne ce vrei să obții, ce public ai în minte și când ai vrea să pornim.",
  },
  interestOptions: [
    "Campanie digitală",
    "Activare în campus",
    "Sampling",
    "Employer branding",
    "Parteneriat ISIC / Cardul European de Tineret",
    "Altceva",
  ],
  submit: "Trimite mesajul",
};

export const PARTNER_META = {
  heineken: {
    summary: "Un parteneriat construit în timp, de la comunicare digitală până la sampling și experiențe directe cu studenții.",
    facts: ["2023, prezent", "150.000+ produse distribuite", "Sampling", "Digital + campus + evenimente"],
  },
  logitech: {
    summary: "Am dus produsele Logitech din feed direct în campus, prin experiențe hands-on, gaming, demonstrații de produs, concursuri și campanii digitale dedicate studenților.",
    facts: ["Activări în campus", "Product trial", "Gaming & concursuri", "Digital amplification"],
  },
  sephora: {
    summary: "Am adus Sephora mai aproape de comunitatea studențească printr-o experiență construită în jurul beauty, interacțiunii directe și prezenței în campus.",
    facts: ["300+ participante", "Universitatea din București", "Eveniment + campus", "Digital amplification"],
  },
  brd: {
    summary: "Încă din 2005, BRD și ISIC scriu împreună una dintre cele mai longevive și solide povești dedicate studenților din România.",
    facts: ["2005, prezent", "Card BRD–ISIC · comision 0", "Prezență în campus", "Materiale offline"],
  },
  kaufland: {
    summary: "Parteneriatul cu Kaufland a început în 2015 și a devenit, în timp, unul dintre cele mai solide și extinse proiecte din regatul tinerilor.",
    facts: ["2015, prezent", "Employer branding", "Legitimații co-brand", "Campus + ISIC Jobs"],
  },
  yoxo: {
    summary: "Din 2021, YOXO și Făt-Frumos merg pe același drum, într-o poveste construită pas cu pas, aproape de studenți și de stilul lor de viață.",
    facts: ["2021, prezent", "Sampling cartele", "Evenimente & campus", "Legitimații co-branded"],
  },
  istyle: {
    summary: "Parteneriatul cu iSTYLE România a început în 2016 și s-a construit constant, în jurul pasiunii pentru tehnologie, educație și comunitatea tânără.",
    facts: ["2016, prezent", "Workshop-uri în universități", "Produse Apple", "Digital + concursuri"],
  },
  samsung: {
    summary: "Parteneriatul cu Samsung a început în 2022 și s-a consolidat rapid, devenind principalul canal prin care brandul comunică direct cu studenții și tinerii din România.",
    facts: ["2022, prezent", "Promovare online națională", "Concursuri în campus", "Caravana ISIC"],
  },
  "turkish-airlines": {
    summary: "Colaborarea cu Turkish Airlines a început în 2019, cu un obiectiv clar: să aducem mai aproape de studenți tarifele dedicate lor și beneficiile de călătorie oferite de unul dintre cele mai importante branduri din aviație.",
    facts: ["2019, prezent", "Tarife dedicate studenților", "Online: NL, push, social", "Prezență offline în campus"],
  },
};

const brandLogo = (slug) => (BRANDS.find((b) => b.slug === slug) || {}).logo;

export const PARTNERS = {
  logitech: {
    name: "Logitech",
    logo: brandLogo("logitech"),
    title: "Povestea Logitech",
    intro: [
      "De-a lungul colaborării noastre, Logitech a ales să fie prezent exact acolo unde pasiunea pentru tehnologie, gaming și creativitate prinde viață. Împreună am construit campanii care au îmbinat vizibilitatea online cu experiențe reale, interactive, gândite special pentru tineri și studenți.",
      "Am dus brandul mai aproape de comunitatea noastră prin acțiuni coerente, bine ancorate în lumea lor. De la ecran, direct în campus.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Standuri interactive în campusuri",
        body: [
          "Un capitol important al colaborării cu Logitech a fost prezența fizică în campusuri universitare, prin standuri interactive dedicate.",
          "Standul prezentat în imaginile de mai jos a avut loc în Universitatea Tehnică de Construcții din București, unde studenții au putut testa produsele Logitech, interacționa direct cu brandul și descoperi soluții de gaming și productivitate într-un context natural pentru ei.",
          "Prezența în campus a permis un dialog direct, hands-on, cu un public relevant, într-un spațiu cu trafic constant și interes real pentru tehnologie.",
        ],
      },
      {
        title: "Campanii online și concursuri dedicate",
        body: [
          "Am completat activările offline cu campanii online care au menținut atenția și interesul comunității. Prin concursuri digitale și mecanici gândite special pentru studenți, Logitech a reușit să genereze engagement autentic și conversații relevante.",
          "Aceste campanii au fost construite astfel încât să pună în valoare produsele Logitech, dar și inițiativele și proiectele speciale ale brandului.",
        ],
      },
      {
        title: "Landing page-uri și conținut dedicat",
        body: [
          "Pentru a susține campaniile, am creat landing page-uri dedicate, care au funcționat ca punct central de comunicare.",
          "Aici, studenții au putut descoperi produsele Logitech, campaniile active, dar și alte inițiative importante ale brandului, într-un format clar, accesibil și adaptat nevoilor lor.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2025/10/image00005-scaled-1.jpeg",
        "/brand-assets/2025/10/image00011-scaled-1.jpeg",
        "/brand-assets/2025/10/image00012-scaled-1.jpeg",
        "/brand-assets/2025/10/image00018-scaled-1.jpeg",
      ],
      },
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2026/01/fb4-1.png",
        "/brand-assets/2026/01/fb5.png",
        "/brand-assets/2026/01/fb2-1.png",
        "/brand-assets/2026/01/fb1-1.png",
        "/brand-assets/2026/01/ASLS-Logi-Cewe-ss.png",
        "/brand-assets/2026/01/ss-push-logitech.png",
        "/brand-assets/2026/01/NL2.jpg",
        "/brand-assets/2026/01/SSMB.jpg",
        "/brand-assets/2026/01/banner.png",
      ],
      },
    ],
  },
  heineken: {
    name: "Heineken",
    logo: brandLogo("heineken"),
    title: "Povestea Heineken",
    video: "https://player.vimeo.com/video/1108400178?app_id=122963&title=0&byline=0&portrait=0",
    intro: [
      "Începând cu 2023, Heineken este un partener constant în proiectele noastre dedicate studenților și tinerilor. Împreună am dezvoltat campanii care au combinat experiențele directe din teren cu susținerea lor în online, astfel încât mesajele brandului să ajungă în mod relevant la publicul vizat.",
      "De la acțiuni de sampling și activări în campusuri sau la festivaluri, până la promovarea unor evenimente și lansări de produs, colaborarea cu Heineken s-a desfășurat printr-un mix coerent de canale, construit pentru vizibilitate și interacțiune reală.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Sampling și activări offline, la nivel național",
        body: [
          "Am dus Heineken direct în mijlocul studenților prin acțiuni de sampling desfășurate la evenimente de tineri, în campusuri universitare și în cadrul unor activări dedicate. Aceste acțiuni au creat interacțiuni directe, au generat conversații și au transformat produsul într-o experiență trăită, nu doar comunicată.",
          "Un exemplu relevant este lansarea Ciuc Radler Mix Tropical, pentru care am implementat atât campanii online de amploare, cât și acțiuni de sampling la nivel național, astfel încât produsul să fie descoperit direct de publicul tânăr.",
        ],
      },
      {
        title: "Standuri și activări speciale",
        body: [
          "Am creat și activări cu standuri tematice, concepute pentru a atrage atenția și a genera engagement.",
          "Un moment emblematic a fost activarea „Player 0.0” cu Max Verstappen, unde am adus simulatoare de Formula 1 în Politehnica București, transformând campusul într-un punct de atracție pentru studenți și pasionați de experiențe interactive.",
        ],
      },
      {
        title: "Promovare online și amplificare digitală",
        body: [
          "Componenta offline a fost susținută constant de campanii online, prin care am dus mesajele Heineken către sute de mii de tineri.",
          "Am promovat evenimente și concerte precum Heineken Refresh Your Music, dar și lansări de produs, folosind un mix de canale digitale adaptate publicului tânăr:",
          { ul: ["newslettere dedicate către comunitatea noastră", "promovare prin federații și asociații studențești și de tineret la nivel național"] },
        ],
      },
      {
        title: "O poveste care merge mai departe",
        body: [
          "Colaborarea cu Heineken este un exemplu de integrare firească între online și offline, între experiență și comunicare. Împreună am construit campanii care au ajuns în campusuri, la evenimente, în feed-uri și în conversațiile tinerilor.",
          "Povestea merge mai departe, cu aceeași dorință de a rămâne relevanți, autentici și aproape de publicul tânăr.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2025/12/WhatsApp-Image-2025-12-10-at-13.33.10.jpeg",
        "/brand-assets/2025/12/WhatsApp-Image-2025-12-10-at-13.33.10-1.jpeg",
        "/brand-assets/2025/10/DSC_0285-1-scaled-1.jpg",
        "/brand-assets/2025/10/DSC_0139-1-scaled-1.jpg",
        "/brand-assets/2025/10/h1-1-scaled-1.jpg",
        "/brand-assets/2025/10/h4-1.jpg",
        "/brand-assets/2025/10/h3-1.jpg",
        "/brand-assets/2025/10/h2-1-scaled-1.jpg",
      ],
      },
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2025/12/Picture2.png",
        "/brand-assets/2025/12/Screenshot-2025-12-18-155825.png",
        "/brand-assets/2025/12/Picture1.png",
        "/brand-assets/2026/01/Screenshot-2026-01-09-134350-1.png",
        "/brand-assets/2025/12/Screenshot-2025-12-18-160016.png",
        "/brand-assets/2025/12/Screenshot-2025-12-19-111258.png",
        "/brand-assets/2026/01/Screenshot-2026-01-12-112026.png",
        "/brand-assets/2026/01/Screenshot-2026-01-12-111808.png",
      ],
      },
    ],
  },
  sephora: {
    name: "Sephora",
    logo: brandLogo("sephora"),
    title: "Povestea Sephora",
    intro: [
      "De-a lungul colaborării noastre, Sephora a ales să fie prezentă aproape de studenți și tineri printr-un mix echilibrat de acțiuni online și offline. Împreună am construit campanii care au dus brandul din ecrane direct în campusuri universitare și în contexte reale de interacțiune.",
      "Am creat vizibilitate constantă, adaptată publicului tânăr, și am integrat Sephora în momente relevante pentru comunitatea noastră.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Vizibilitate offline în campusuri universitare",
        body: [
          "Un element-cheie al colaborării a fost prezența fizică a brandului Sephora în campusuri universitare, prin distribuția de flyere și materiale promoționale dedicate.",
          "Acestea au ajuns direct la studenți, în spațiile în care aceștia își petrec timpul zilnic, contribuind la creșterea notorietății brandului într-un mod firesc și relevant.",
        ],
      },
      {
        title: "Eveniment de amploare",
        body: [
          "Am organizat un eveniment dedicat în Aula Magna a Universității din București, unde peste 300 de studente au participat la o experiență beauty completă, cu ateliere interactive, demonstrații de machiaj și goodie bags special pregătite.",
        ],
      },
      {
        title: "Campanii online complementare",
        body: [
          "Acțiunile offline au fost susținute de campanii online, care au amplificat mesajele și au menținut brandul relevant în mediul digital.",
          "Prin prezență constantă și conținut adaptat, Sephora a reușit să rămână conectată cu tinerii și dincolo de interacțiunile din campus.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2025/10/20191015_133246-1-scaled-1.jpg",
        "/brand-assets/2025/10/20191015_141350-1-scaled-1.jpg",
        "/brand-assets/2025/10/IMG_5792-scaled-1.jpg",
        "/brand-assets/2025/10/IMG_5775-scaled-1.jpg",
      ],
      },
      {
        title: "Materiale create special pentru Sephora",
        images: [
        "/brand-assets/2026/02/Sephora_Magazine.jpg",
        "/brand-assets/2026/02/Sephora_Rollup.png",
        "/brand-assets/2026/02/Sephora_poster.png",
        "/brand-assets/2026/02/Sephora_Cartolina.png",
      ],
      },
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2026/01/ss-sephora-facebook-2.png",
        "/brand-assets/2026/01/ss-sephora-facebook-3.png",
        "/brand-assets/2026/01/ss-sephora-facebook.png",
      ],
      },
    ],
  },
  brd: {
    name: "BRD",
    logo: brandLogo("brd"),
    title: "Povestea BRD",
    intro: [
      "Încă din 2005, BRD și ISIC scriu împreună una dintre cele mai longevive și solide povești dedicate studenților din România. Parteneriatul nostru a dat naștere produsului BRD–ISIC, un card bancar cu comision 0 pentru studenți, recunoscut la nivel internațional și conectat la rețeaua globală de reduceri ISIC.",
      "Este o colaborare construită pe termen lung, care investește în relația cu studenții încă din primii ani de facultate.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "BRD–ISIC, un produs gândit pentru studenți",
        body: [
          "BRD–ISIC este mai mult decât un card bancar. Este un instrument care îi însoțește pe studenți pe parcursul anilor universitari, oferindu-le servicii bancare adaptate nevoilor lor și acces la beneficiile ISIC, recunoscute în toată lumea.",
        ],
      },
      {
        title: "Prezență constantă în universități, la nivel național",
        body: [
          "În fiecare an, organizăm împreună standuri dedicate BRD–ISIC în universități din toată țara, unde interacționăm direct cu un număr mare de studenți care aplică pentru card. Aceștia sunt întâmpinați într-un context prietenos și informativ, cu goodie bags pregătite special pentru ei.",
        ],
      },
      {
        title: "Materiale de marketing offline, create pentru campus",
        body: [
          "Susținem anual activările BRD–ISIC printr-o gamă amplă de materiale de marketing offline, concepute special pentru mediul universitar:",
          "broșuri, flyere, roll-ups dedicate, dar și kit-uri studențești care includ reviste, clipboard-uri, caiete, produse de birotică, băuturi, snacks-uri și alte materiale utile pentru viața de student.",
        ],
      },
      {
        title: "O investiție pe termen mediu și lung",
        body: [
          "Parteneriatul cu BRD este un exemplu de marketing cu viziune. Studentul de astăzi devine angajatul de mâine, iar relația construită încă din facultate se continuă natural atunci când apar nevoi financiare mai complexe, precum economisirea sau accesarea unui credit.",
        ],
      },
      {
        title: "O poveste care continuă",
        body: [
          "BRD–ISIC este o colaborare care a trecut testul timpului. De peste două decenii, construim împreună un pod între studenți și viitorul lor financiar, printr-un produs relevant, accesibil și recunoscut internațional.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2025/10/caravana-10-scaled-1.jpg",
        "/brand-assets/2025/10/caravana-11.jpg",
        "/brand-assets/2025/10/c4.jpg",
        "/brand-assets/2026/01/caravana-8.jpg",
        "/brand-assets/2026/01/ISIC-European-Youth-Card.png",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-13.29.12.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-13.26.44.jpeg",
        "/brand-assets/2026/01/caravana-7.jpg",
      ],
      },
      {
        title: "Materiale create special pentru activările BRD–ISIC",
        images: [
        "/brand-assets/2026/01/BRD_Rollup.png",
        "/brand-assets/2026/01/BRD_Pliant.png",
        "/brand-assets/2026/01/BRD_Tote.png",
        "/brand-assets/2026/01/BRD_Vesta.jpg",
        "/brand-assets/2026/01/BRD_Flyer.jpg",
        "/brand-assets/2026/01/BRD_Articol.jpg",
      ],
      },
    ],
  },
  kaufland: {
    name: "Kaufland",
    logo: brandLogo("kaufland"),
    title: "Povestea Kaufland",
    intro: [
      "Parteneriatul cu Kaufland a început în 2015 și a devenit, în timp, unul dintre cele mai solide și extinse proiecte din regatul tinerilor. De-a lungul anilor, am lucrat împreună pentru a aduce brandul mai aproape de studenți, cu un focus constant pe employer branding și pe construirea unei relații pe termen lung cu viitorii angajați.",
      "Kaufland este prezent constant în acțiunile, materialele și proiectele dedicate studenților, atât online, cât și offline.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Employer branding, online și în campus",
        body: [
          "Am susținut Kaufland printr-un mix amplu de acțiuni online și prezență constantă pe platforma ISIC Jobs, unde oportunitățile de carieră au ajuns direct la studenții interesați.",
          "Aceste acțiuni au fost completate de o prezență activă în campusuri universitare, prin standuri dedicate și participări la evenimente pentru studenți, mici sau mari, unde am prezentat direct oportunitățile de carieră Kaufland și am creat contexte de dialog real cu tinerii.",
        ],
      },
      {
        title: "Legitimații co-brand și vizibilitate pe termen lung",
        body: [
          "Un element central al colaborării îl reprezintă legitimațiile co-brand ISIC – Kaufland, în care dedicăm spațiu mesajelor de employer branding.",
          "Legitimațiile au o valabilitate de până la 16 luni, perioadă în care mesajul Kaufland rămâne constant vizibil în viața de zi cu zi a studenților.",
          "Este o formă de comunicare pe termen mediu și lung, care însoțește studentul din campus până în primii ani de carieră.",
        ],
      },
      {
        title: "Prezență în materiale offline",
        body: [
          "Kaufland beneficiază de vizibilitate masivă în materialele offline pe care le dezvoltăm anual: reviste, broșuri, flyere și alte materiale de comunicare, distribuite masiv în campusuri universitare din toată țara.",
          "În cadrul Caravanei ISIC, organizată în fiecare toamnă, includem întotdeauna materiale personalizate Kaufland în kiturile studențești. De-a lungul timpului, acestea au inclus caiete, clipboard-uri, calendare și alte materiale utile, gândite special pentru viața de student.",
        ],
      },
      {
        title: "Standuri dedicate și interacțiuni directe",
        body: [
          "La evenimentele studențești, Kaufland este prezent prin standuri dedicate, unde discutăm direct cu tinerii despre carieră, oportunități de angajare și parcurs profesional.",
          "Broșurile, materialele informative și discuțiile față în față completează strategia de employer branding, într-un mod autentic și relevant.",
        ],
      },
      {
        title: "Un parteneriat de referință",
        body: [
          "Colaborarea cu Kaufland este un exemplu de construcție pe termen lung, cu impact real. De peste un deceniu, brandul este prezent constant în viața studenților, printr-un mix coerent de online, offline și comunicare directă.",
          "Este o poveste care continuă și care demonstrează că employer brandingul făcut bine începe din campus.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-15.23.29-1.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-15.23.29.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-15.19.50.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-15.12.12.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-15.01.49.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-13-at-15.02.12.jpeg",
      ],
      },
      {
        title: "Materiale create special pentru Kaufland",
        images: [
        "/brand-assets/2026/01/Kaufland_Stand.jpg",
        "/brand-assets/2026/01/Kaufland_Caseta_Luminoasa_2025.png",
        "/brand-assets/2026/01/Kaufland_Card_Digital_2025.png",
        "/brand-assets/2026/01/Kaufland_ISIC_Jobs.png",
        "/brand-assets/2026/01/Kaufland_Caiet.png",
        "/brand-assets/2026/01/Kaufland_ISIC_Magazine.png",
        "/brand-assets/2026/01/Kaufland_Clipboard.png",
        "/brand-assets/2026/01/Kaufland_Planner.jpg",
      ],
      },
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2026/01/fb-kaufland-1.png",
        "/brand-assets/2026/01/kaufland-fb-1-1.png",
        "/brand-assets/2026/01/kaufland-fb-2-1.png",
        "/brand-assets/2026/01/kaufland-fb-3-1.png",
        "/brand-assets/2026/01/NL-Kaufland-1.jpg",
        "/brand-assets/2026/01/ss-push-kaufland.png",
      ],
      },
    ],
  },
  yoxo: {
    name: "YOXO",
    logo: brandLogo("yoxo"),
    title: "Povestea YOXO",
    intro: [
      "Din 2021, YOXO și Făt-Frumos merg pe același drum, într-o poveste construită pas cu pas, aproape de studenți și de stilul lor de viață. Împreună am creat campanii care au combinat prezența online cu experiențe reale, în campusuri, la evenimente mari și în momente-cheie pentru tineri.",
      "De la activări cu energie mare, la interacțiuni directe și vizibilitate constantă pe termen lung, YOXO a fost mereu acolo unde sunt studenții – iar noi am avut grijă ca mesajul lor să ajungă exact unde trebuie.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Prezență fizică la evenimente mari pentru studenți",
        body: [
          "Unul dintre cele mai spectaculoase capitole a fost prezența YOXO la un eveniment major dedicat studenților, organizat pe litoral. Acolo am creat un spațiu recognoscibil și memorabil, cu elemente care au atras atenția și au generat interacțiuni naturale:",
          {
            ul: [
              "photo prop personalizat YOXO",
              "stickere cu mesaje custom, create special pentru publicul tânăr",
              "veste personalizate, purtate de studenți în cadrul turneelor de fotbal și handbal",
              "zone de interacțiune care au transformat brandul într-o experiență, nu doar într-un mesaj",
            ],
          },
        ],
      },
      {
        title: "Sampling și activări în campusuri universitare",
        body: [
          "Am dus YOXO direct în universități, prin acțiuni de sampling cu cartele YOXO, desfășurate în campusuri din toată țara.",
          "În plus, YOXO a fost alături de noi la standurile din campusuri, beneficiind de traficul generat de acțiunile din Caravana ISIC. Acolo, echipa lor a avut ocazia să prezinte direct produsul studenților, într-un context prietenos și relevant.",
        ],
      },
      {
        title: "Vizibilitate constantă prin legitimații co-branded",
        body: [
          "Un pilon important al colaborării a fost realizarea, în fiecare an, a legitimațiilor co-branded ISIC – YOXO.",
          "Acestea au reprezentat un canal de promovare cu impact pe termen lung, având o valabilitate de 16 luni, perioadă în care brandul YOXO a fost vizibil constant în viața de zi cu zi a studenților.",
        ],
      },
      {
        title: "Campanii online, acolo unde tinerii sunt zilnic",
        body: [
          "Am completat activările offline cu campanii online, care au dus mesajul YOXO către mii de studenți, prin canale relevante pentru ei.",
          "Online-ul a fost liantul care a menținut conversația vie, înainte, în timpul și după acțiunile din teren.",
        ],
      },
      {
        title: "Povestea continuă",
        body: [
          "YOXO rămâne un partener care înțelege generația tânără și care a ales să fie prezent acolo unde contează cu adevărat: în campusuri, la evenimente, pe telefon și în viața reală a studenților.",
          "Iar noi continuăm să scriem această poveste, an după an.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2026/05/WhatsApp-Image-2026-05-11-at-10.39.24.jpeg",
        "/brand-assets/2026/05/WhatsApp-Image-2026-04-03-at-13.22.51.jpeg",
        "/brand-assets/2026/01/stand-3-1-scaled.jpeg",
        "/brand-assets/2026/01/poza-2.jpg",
        "/brand-assets/2026/05/WhatsApp-Image-2026-05-11-at-10.39.44-1.jpeg",
        "/brand-assets/2026/05/WhatsApp-Image-2026-03-17-at-12.10.41.jpeg",
        "/brand-assets/2026/01/stand-2-14-1.jpg",
        "/brand-assets/2026/01/poza-8-1.jpeg",
        "/brand-assets/2026/01/poza-10-scaled.jpg",
        "/brand-assets/2026/01/poza-15-1-scaled.jpg",
      ],
      },
      {
        title: "Materiale create special pentru YOXO",
        images: [
        "/brand-assets/2026/02/YOXO_Card_Plastic_ISIC.png",
        "/brand-assets/2026/02/YOXO_Magazine.jpg",
        "/brand-assets/2026/02/YOXO_Rollup.png",
        "/brand-assets/2026/02/YOXO_Vesta.png",
        "/brand-assets/2026/02/mockup_final_Part1.jpg",
      ],
      },
      {
        title: "Câteva exemple de acțiuni online",
        images: [
        "/brand-assets/2026/01/ss-yoxo-facebook.png",
        "/brand-assets/2026/01/ls-story.jpg",
        "/brand-assets/2026/01/ss-push-yoxo.png",
        "/brand-assets/2026/01/ss_NL_yoxo.png",
        "/brand-assets/2026/01/ss-FB-22.11.2023.png",
        "/brand-assets/2026/01/ss-yoxo-facebook-2.png",
      ],
      },
    ],
  },
  istyle: {
    name: "iStyle",
    logo: brandLogo("istyle"),
    title: "Povestea iSTYLE",
    intro: [
      "Parteneriatul cu iSTYLE România a început în 2016 și s-a construit constant, în jurul pasiunii pentru tehnologie, educație și comunitatea tânără. Împreună am adus produsele Apple mai aproape de studenți, atât prin promovare online, cât și prin experiențe offline relevante, gândite special pentru domeniile pe care aceștia le studiază.",
      "Colaborarea noastră a pus accent pe context real, pe învățare și pe exemple concrete de utilizare a tehnologiei în viitoarele meserii ale studenților.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Workshop-uri dedicate în universități",
        body: [
          "Un pilon important al colaborării a fost organizarea de workshop-uri dedicate studenților, desfășurate în unele dintre cele mai importante universități din București:",
          {
            ul: [
              "Politehnica București – pentru studenții de la Automatică și Calculatoare",
              "Universitatea din București – pentru studenții de la Jurnalism",
              "Universitatea de Arhitectură și Urbanism „Ion Mincu” – pentru studenții arhitecți",
            ],
          },
          "Aceste workshop-uri au fost construite pe nevoile reale ale fiecărei specializări, oferind exemple concrete de utilizare a produselor Apple în domenii precum tehnologia, media și arhitectura.",
        ],
      },
      {
        title: "Conținut relevant, spus de profesioniști",
        body: [
          "La evenimentele organizate alături de iSTYLE au participat profesioniști recunoscuți din domeniile respective, care le-au vorbit studenților despre experiența lor, parcursul profesional și modul în care folosesc produsele Apple în activitatea de zi cu zi.",
          "Astfel, studenții au avut acces la perspective reale și aplicate, nu doar la prezentări de produs.",
        ],
      },
      {
        title: "Promovare online și concursuri dedicate",
        body: [
          "Am susținut aceste inițiative prin promovare online constantă, campanii dedicate și concursuri online, care au crescut vizibilitatea proiectelor și au încurajat participarea.",
          "Premiile oferite au contribuit la engagement și au menținut interesul comunității pentru activitățile iSTYLE.",
        ],
      },
      {
        title: "O colaborare construită în timp",
        body: [
          "Colaborarea cu iSTYLE România este un exemplu de proiect construit pe termen lung, în care tehnologia, educația și comunitatea se întâlnesc natural. De-a lungul anilor, am creat contexte relevante în care produsele Apple au fost integrate firesc în parcursul academic și profesional al studenților.",
          "Povestea continuă, cu același focus pe valoare, experiență și dialog real cu tinerii.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva poze de la activări",
        images: [
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-26-at-14.46.35-1.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-26-at-14.53.14-2.jpeg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-26-at-14.50.42-1.jpeg",
        "/brand-assets/2026/01/Picture5.jpg",
        "/brand-assets/2026/01/WhatsApp-Image-2026-01-26-at-14.53.14-1-1.jpeg",
        "/brand-assets/2026/01/Picture6.jpg",
      ],
      },
      {
        title: "Materiale create special pentru iSTYLE",
        images: [
        "/brand-assets/2026/02/iStyle_Magazine2.jpg",
        "/brand-assets/2026/02/iStyle_Flyer.jpg",
        "/brand-assets/2026/02/iStyle_Magazine.jpg",
      ],
      },
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2026/01/screencapture-mail-google-mail-u-0-2026-01-27-10_16_25.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-101304.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-102144.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-102234.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-102325.png",
      ],
      },
    ],
  },
  samsung: {
    name: "Samsung",
    logo: brandLogo("samsung"),
    title: "Povestea Samsung",
    intro: [
      "Parteneriatul cu Samsung a început în 2022 și s-a consolidat rapid, devenind principalul canal prin care brandul comunică direct cu studenții și tinerii din România. Împreună am construit campanii care au dus produsele și mesajele Samsung acolo unde publicul tânăr este activ, atât în mediul digital, cât și în campusuri universitare.",
      "Colaborarea noastră are la bază vizibilitatea constantă, adaptarea mesajelor și construirea unei prezențe relevante în rândul noii generații.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Promovare online, la scară națională",
        body: [
          "Am susținut Samsung printr-un mix amplu de campanii online, gândite special pentru publicul tânăr. Acestea au inclus:",
          {
            ul: [
              "campanii sponsorizate în social media",
              "newslettere dedicate",
              "push notifications",
              "promovare prin asociații studențești la nivel național",
            ],
          },
          "Prin aceste canale, mesajele Samsung au ajuns direct la studenți, în contexte relevante și cu impact.",
        ],
      },
      {
        title: "Concursuri și activări pentru comunitatea de studenți",
        body: [
          "Pentru a crește interacțiunea, am organizat concursuri online, dar și concursuri desfășurate în campusurile universitare, care au generat participare, engagement și contact direct cu brandul.",
        ],
      },
      {
        title: "Prezență offline în Caravana ISIC",
        body: [
          "Samsung a fost promovat și în cadrul Caravanei ISIC, prin materiale de comunicare offline dedicate, distribuite și afișate în campusuri universitare din toată țara.",
          "Am integrat brandul prin flyere, roll-up-uri și postere, asigurând vizibilitate constantă în puncte cu trafic ridicat și contact direct cu studenții care aplică pentru legitimația ISIC.",
        ],
      },
      {
        title: "Un parteneriat construit pe relevanță",
        body: [
          "Samsung este un partener-cheie în comunicarea către studenți și tineri, iar colaborarea noastră reflectă o strategie coerentă, construită pe termen mediu și lung. Împreună am creat o prezență constantă, adaptată generației tinere și canalelor pe care aceasta le folosește zilnic.",
          "Povestea continuă, cu aceeași direcție: vizibilitate, interacțiune și impact real în comunitatea tânără.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2026/01/samsung-facebook-2.png",
        "/brand-assets/2026/01/samsung-facebook-3.png",
        "/brand-assets/2026/01/samsung-facebook-4.png",
        "/brand-assets/2026/01/samsung-facebook-5.png",
        "/brand-assets/2026/01/ASUS.jpg",
        "/brand-assets/2026/01/ASLS.png",
        "/brand-assets/2026/01/NL-samsung-black-1.png",
        "/brand-assets/2026/01/site-banner-s25.png",
        "/brand-assets/2026/01/ss-NL-Samsung-august.png",
        "/brand-assets/2026/01/samsung-facebook.png",
      ],
      },
    ],
  },
  "turkish-airlines": {
    name: "Turkish Airlines",
    logo: brandLogo("turkish-airlines"),
    title: "Povestea Turkish Airlines",
    intro: [
      "Colaborarea cu Turkish Airlines a început în 2019, cu un obiectiv clar: să aducem mai aproape de studenți tarifele dedicate lor și beneficiile de călătorie oferite de unul dintre cele mai importante branduri din aviație. Împreună am construit o prezență constantă, care a conectat ofertele Turkish Airlines cu nevoile reale ale tinerilor care studiază, călătoresc și explorează.",
      "Parteneriatul nostru a fost gândit pe termen lung, cu focus pe vizibilitate, relevanță și accesibilitate pentru comunitatea de studenți.",
    ],
    sectionsTitle: "Ce am construit împreună",
    sections: [
      {
        title: "Promovare online, către comunitatea de studenți",
        body: [
          "Am susținut Turkish Airlines printr-un mix de acțiuni online, adaptate publicului tânăr, similar cu cele dezvoltate pentru alți parteneri din portofoliu.",
          "Promovarea tarifelor pentru studenți a fost realizată prin:",
          {
            ul: [
              "campanii în social media",
              "newslettere dedicate",
              "push notifications",
              "promovare prin asociații studențești și de tineret la nivel național",
            ],
          },
          "Aceste canale au permis transmiterea mesajelor într-un mod direct și eficient, exact acolo unde studenții sunt activi.",
        ],
      },
      {
        title: "Prezență constantă pe platformele noastre web",
        body: [
          "Turkish Airlines beneficiază de prezență permanentă pe paginile noastre web, inclusiv pe paginile dedicate parteneriatelor academice.",
          "Această vizibilitate asigură expunere continuă a ofertei lor pentru studenți și menține brandul relevant pe toată durata anului universitar.",
        ],
      },
      {
        title: "Promovare offline în campusuri",
        body: [
          "Componenta online a fost completată de promovare offline, prin materiale dedicate distribuite în campusuri universitare.",
          "Am integrat Turkish Airlines în acțiuni cu flyere și roll-up-uri, precum și prin spații dedicate de promovare în revista anuală ISIC Student Magazine, distribuită masiv studenților din toată țara.",
        ],
      },
      {
        title: "Un parteneriat construit pentru mobilitatea tinerilor",
        body: [
          "Colaborarea cu Turkish Airlines este un exemplu de comunicare coerentă, construită în jurul nevoilor reale ale studenților. Prin acest parteneriat, tarifele dedicate au ajuns constant la cei care călătoresc pentru studii, experiențe internaționale sau descoperire.",
          "Povestea continuă, cu aceeași direcție: accesibilitate, vizibilitate și conectare cu generația tânără.",
        ],
      },
    ],
    galleries: [
      {
        title: "Câteva exemple de acțiuni în lumea digitală",
        images: [
        "/brand-assets/2026/01/Screenshot-2026-01-27-120916.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-121907.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-121210.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-121822.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-122154.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-122950.png",
        "/brand-assets/2026/01/Screenshot-2026-01-27-122911.png",
      ],
      },
    ],
  },
};

export const FOOTER = {
  cta: "Cu povești spuse bine și toți balaurii învinși",
  copyright: "© Făt Frumos 2026 | Cu povești spuse bine și toți balaurii învinși",
  projectsTitle: "Proiectele noastre",
  quickTitle: "Link-uri rapide",
  quick: [
    { label: "Despre noi", to: "/despre-noi" },
    { label: "Ce oferim", to: "/ce-oferim" },
    { label: "Servicii custom", to: "/campanii-custom" },
    { label: "Contactează-ne", to: "/contact" },
  ],
};
